import React from "react";
import styled from "styled-components";
import { FaPlay } from "react-icons/fa";

const History = () => {
  return (
    <Wrapper>
      <section className="rs-history-area section-space rs-history-one">
        <div
          className="rs-history-bg-thumb"
          style={{
            backgroundImage: "url(/assets/images/bg/tab-bg-01.png)",
          }}
        ></div>
        <div className="container">
          <div className="row g-5 justify-content-center section-title-space align-items-center">
            <div className="col-xxl-6 col-xl-6 col-lg-6">
              <div className="rs-section-title-wrapper text-center">
                <span className="rs-section-subtitle has-theme-orange">
                  <FaPlay color="#EA5501" size={12} />
                  Our History
                </span>
                <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                  Company Journey
                </h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xxl-9 col-xl-10">
              <div className="rs-history-tab-wrapper">
                <div className="rs-history-tab">
                  <div className="history-scroll">
                    <ul
                      className="nav nav-pills flex-nowrap"
                      id="pills-tab-two"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="pills-item-four-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-item-four"
                          type="button"
                          role="tab"
                          aria-controls="pills-item-four"
                          aria-selected="true"
                        >
                          In 1990
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-item-five-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-item-five"
                          type="button"
                          role="tab"
                          aria-controls="pills-item-five"
                          aria-selected="false"
                        >
                          In 2000
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-item-six-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-item-six"
                          type="button"
                          role="tab"
                          aria-controls="pills-item-six"
                          aria-selected="false"
                        >
                          In 2015
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-item-seven-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-item-seven"
                          type="button"
                          role="tab"
                          aria-controls="pills-item-seven"
                          aria-selected="false"
                        >
                          In 2018
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-item-eight-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-item-eight"
                          type="button"
                          role="tab"
                          aria-controls="pills-item-eight"
                          aria-selected="false"
                        >
                          In 2020
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-item-nine-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-item-nine"
                          type="button"
                          role="tab"
                          aria-controls="pills-item-nine"
                          aria-selected="false"
                        >
                          In 2022
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="pills-item-ten-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-item-ten"
                          type="button"
                          role="tab"
                          aria-controls="pills-item-ten"
                          aria-selected="false"
                        >
                          In 2023
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="rs-history-tab-content-wrapper">
                  <div
                    className="tab-content rs-history-tab-anim"
                    id="pills-tabContent-two"
                  >
                    {/* In 1990 */}
                    <div
                      className="tab-pane fade show active"
                      id="pills-item-four"
                      role="tabpanel"
                      aria-labelledby="pills-item-one-tab"
                      tabindex="0"
                    >
                      <div className="rs-history-tab-item">
                        <div className="rs-history-tab-thumb">
                          <img
                            src="/assets/images/history/history-thumb-01.png"
                            alt="imagee"
                          />
                        </div>
                        <div className="rs-history-tab-content">
                          <h5 className="rs-history-tab-title">
                            {/* Journey Was Started */}
                            Our Journey
                          </h5>
                          <p>
                            The journey began with small-scale manufacturing of
                            tobacco products and soap, marking the humble
                            origins of Eque Group.
                          </p>
                          <div className="rs-history-tab-list d-none">
                            <div className="rs-list-item">
                              <ul>
                                <li>Quality Control System</li>
                                <li>Building Quality Industrial</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* In 2000 */}
                    <div
                      className="tab-pane fade"
                      id="pills-item-five"
                      role="tabpanel"
                      aria-labelledby="pills-item-two-tab"
                      tabindex="0"
                    >
                      <div className="rs-history-tab-item">
                        <div className="rs-history-tab-thumb">
                          <img
                            src="/assets/images/history/history-thumb-02.png"
                            alt="imagee"
                          />
                        </div>
                        <div className="rs-history-tab-content">
                          <h5 className="rs-history-tab-title">
                            {/* Journey Was Started */}
                            Our Journey
                          </h5>
                          <p>
                            Establishment of the Jute Mill, entering a key
                            traditional and export-oriented industry.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* In 2015 */}
                    <div
                      className="tab-pane fade"
                      id="pills-item-six"
                      role="tabpanel"
                      aria-labelledby="pills-item-three-tab"
                      tabindex="0"
                    >
                      <div className="rs-history-tab-item">
                        <div className="rs-history-tab-thumb">
                          <img
                            src="/assets/images/history/history-thumb-03.png"
                            alt="imagee"
                          />
                        </div>
                        <div className="rs-history-tab-content">
                          <h5 className="rs-history-tab-title">Our Journey</h5>
                          <p>
                            Launch of the Paper Mill, strengthening the Group’s
                            position in manufacturing and industrial production.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* In 2018 */}
                    <div
                      className="tab-pane fade"
                      id="pills-item-seven"
                      role="tabpanel"
                      aria-labelledby="pills-item-four-tab"
                      tabindex="0"
                    >
                      <div className="rs-history-tab-item">
                        <div className="rs-history-tab-thumb">
                          <img
                            src="/assets/images/history/history-thumb-04.png"
                            alt="imagee"
                          />
                        </div>
                        <div className="rs-history-tab-content">
                          <h5 className="rs-history-tab-title">Our Journey</h5>
                          <p>
                            Diversification into the energy sector with the
                            establishment of Eque Filling Station.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* In 2020 */}
                    <div
                      className="tab-pane fade"
                      id="pills-item-eight"
                      role="tabpanel"
                      aria-labelledby="pills-item-five-tab"
                      tabindex="0"
                    >
                      <div className="rs-history-tab-item">
                        <div className="rs-history-tab-thumb">
                          <img
                            src="/assets/images/history/history-thumb-05.png"
                            alt="imagee"
                          />
                        </div>
                        <div className="rs-history-tab-content">
                          <h5 className="rs-history-tab-title">Our Journey</h5>
                          <p>
                            Entry into the hospitality sector with a Resort and
                            Restaurant, offering premium leisure and dining
                            experiences.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* In 2022 */}
                    <div
                      className="tab-pane fade"
                      id="pills-item-nine"
                      role="tabpanel"
                      aria-labelledby="pills-item-nine-tab"
                      tabindex="0"
                    >
                      <div className="rs-history-tab-item">
                        <div className="rs-history-tab-thumb">
                          <img
                            src="/assets/images/history/history-thumb-05.png"
                            alt="imagee"
                          />
                        </div>
                        <div className="rs-history-tab-content">
                          <h5 className="rs-history-tab-title">Our Journey</h5>
                          <p>
                            Expansion into industrial packaging through the
                            establishment of a Woven Bag Manufacturing Factory.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* In 2023 */}
                    <div
                      className="tab-pane fade"
                      id="pills-item-ten"
                      role="tabpanel"
                      aria-labelledby="pills-item-ten-tab"
                      tabindex="0"
                    >
                      <div className="rs-history-tab-item">
                        <div className="rs-history-tab-thumb">
                          <img
                            src="/assets/images/history/history-thumb-05.png"
                            alt="imagee"
                          />
                        </div>
                        <div className="rs-history-tab-content">
                          <h5 className="rs-history-tab-title">Our Journey</h5>
                          <p>
                            Launch of a PP Composite Factory focused on
                            export-oriented production, reinforcing the Group’s
                            global outlook.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .history-scroll {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    /* Firefox */
    scrollbar-width: thin;
    scrollbar-color: #ea5501 #f1f1f1;
  }

  /* Chrome, Edge, Safari */
  .history-scroll::-webkit-scrollbar {
    height: 6px;
  }

  .history-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  .history-scroll::-webkit-scrollbar-thumb {
    background: #ea5501;
    border-radius: 10px;
  }

  /* 🔥 Hover effect (important for visibility) */
  .history-scroll::-webkit-scrollbar-thumb:hover {
    background: #c94300;
  }

  .history-scroll ul {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    min-width: max-content;
  }

  .history-scroll .nav-item {
    flex: 0 0 auto;
  }

  .history-scroll .nav-link {
    white-space: nowrap;
  }
`;

export default History;
